import apiService from '@/providers/apiService';
import AppConstants from '@/appConstants';

export default {
  namespaced: true,
  state: {
    // origins: [],
    filter: [],
    extensions: []
  },
  getters: {},
  mutations: {
    // SET_ORIGINS(state, val) {
    //   state.origins = val
    // },
    SET_FILTERS(state, val) {
      state.filter = val
    },
    SET_EXTENSIONS(state, val) {
      let extension = [];
      val.forEach(item => {
        extension = extension.concat(item.values);
      });
      state.extensions = extension;
    },
  },
  actions: {
    fetchImages(ctx, { params }) {
      return new Promise((resolve, reject) => {
        apiService.get(AppConstants.URL_IMAGE_LIBRARY, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      })
    },
    fetchImageDetail(ctx, { id, params }) {
      return new Promise((resolve, reject) => {
        apiService.get(`${AppConstants.URL_IMAGE_LIBRARY}/${id}`, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      })
    },
    register(ctx, { form, params }) {
      return new Promise((resolve, reject) => {
        apiService.post(AppConstants.URL_IMAGE_LIBRARY, form, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      })
    },
    delete(ctx, { id, params }) {
      return new Promise((resolve, reject) => {
        apiService.delete(`${AppConstants.URL_IMAGE_LIBRARY}/${id}`, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      })
    },
  },
}
